<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.km', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row>
          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete
              :items="items"
              @change="filterListByContrat"
              :label="$t('message.pageKm.contractnum', { value: 'default' })"
              item-value="agreement"
              item-text="agreement"
              multiple
              outlined
              dense
              v-model="payload.contrats"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.agreement }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ payload.contrats.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete
              :items="serailList"
              @change="filterListBySerial"
              :label="$t('message.pageKm.serial', { value: 'default' })"
              item-value="serial"
              item-text="serial"
              multiple
              outlined
              dense
              v-model="payload.series"
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.serial }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ payload.series.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select
              :items="statusList"
              @change="filterListByStatus"
              :label="$t('message.page.contractStatus', { value: 'default' })"
              item-value="statutContractuel"
              item-text="statutContractuel"
              multiple
              outlined
              dense
              v-model="vstatus"
            >
              <template v-slot:item="{ item }">
                {{
                  $t(getLocale(item.statutContractuel), {
                    value: "default",
                  })
                }}
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{
                  $t(getLocale(item.statutContractuel), {
                    value: "default",
                  })
                }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ vstatus.length - 1 }} )
                </span>
              </template>
            </v-select>
          </v-col>

          <v-col class="d-flex" cols="12" sm="2">
            <v-autocomplete
              :items="locoList"
              @change="refreshData"
              :label="$t('message.pageKm.loco', { value: 'default' })"
              item-value="loconum"
              item-text="loconum"
              multiple
              outlined
              dense
              v-model="payload.locomotives"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="payload.locomotives > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("message.select", { value: "default" }) }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.loconum }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  (+{{ payload.locomotives.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="$t('message.page.startDate', { value: 'default' })"
                  readonly
                  :value="startDateDisp"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDateVal"
                no-title
                @input="startDateMenu = false"
                @change="refreshData"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :label="$t('message.page.endDate', { value: 'default' })"
                  readonly
                  :value="endDateDisp"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDateVal"
                no-title
                @input="endDateMenu = false"
                @change="refreshData"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <div class="text-center" v-show="this.progress.chart">
          <v-progress-circular
            :size="50"
            color="#EEBB07"
            indeterminate
          ></v-progress-circular>
        </div>
        <apex-charts
          height="274"
          :options="chartOptions"
          :series="series"
          ref="chart"
        >
        </apex-charts>

        <div class="total">
          {{ $t("message.pageKm.total", { value: "default" }) }}
        </div>
        <div class="distance">{{ totalKm }} km</div>
        <div class="total" style="font-size: 0.8em">
          {{ $t("message.pageKm.since", { value: "default" }) }}
          {{ sinceDate }}
        </div>
        <br />

        <v-row class="mb-5">
          <v-col>
            <v-card>
              <v-card-title class="portal-deep-blue-bg">
                {{ $t("message.page.cumul", { value: "default" }) }}
                <v-icon color="#fff" class="ml-auto"> mdi-train </v-icon>
              </v-card-title>
            </v-card>
            <v-data-table
              :headers="headersTable"
              :items="datasTable"
              class="elevation-1 km"
              hide-default-header
              :loading="progress.totalData"
              :loading-text="$t('message.loadingText', { value: 'default' })"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th
                      style="cursor: pointer"
                      v-for="item in headers"
                      :key="item.value"
                      @click="changeSort(item.value, datasTable)"
                    >
                      {{ item.text }}
                      <v-icon color="#9FAAAF" style="float: right"
                        >mdi-swap-vertical</v-icon
                      >
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:[`item.locomotive`]="{ item }">
                <b>{{ item.locomotive }} </b>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                {{ $t(getLocale(item.status), { value: "default" }) }}
              </template>
              <template v-slot:[`item.distance`]="{ item }">
                {{ formatDistance(item.distance) }}
              </template>
            </v-data-table>
          </v-col>
          <!-- km by month-->
          <v-col>
            <v-card>
              <v-card-title class="portal-deep-blue-bg">
                {{ $t("message.page.moyMonth", { value: "default" }) }}
                <v-icon color="#fff" class="ml-auto"> mdi-train </v-icon>
              </v-card-title>
            </v-card>

            <v-data-table
              :headers="headersMoyTable"
              :items="datasMonthTable"
              class="elevation-1 km"
              hide-default-header
              :loading="progress.avgData"
              :loading-text="$t('message.loadingText', { value: 'default' })"
            >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th
                      style="cursor: pointer"
                      v-for="item in headers"
                      :key="item.value"
                      @click="changeSort(item.value, datasMonthTable)"
                    >
                      {{ item.text }}
                      <v-icon color="#9FAAAF" style="float: right"
                        >mdi-swap-vertical</v-icon
                      >
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:[`item.locomotive`]="{ item }">
                <b>{{ item.locomotive }} </b>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                {{ $t(getLocale(item.status), { value: "default" }) }}
              </template>
              <template v-slot:[`item.distance`]="{ item }">
                {{ formatDistance(item.distance) }}
              </template></v-data-table
            >
          </v-col>
        </v-row>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import ApexCharts from "vue-apexcharts";
import { mapActions, mapGetters } from "vuex";
import {
  firstDateOfCurrentMonth,
  currentDate,
  parseDate,
  parseEndDate,
  formatDate,
  numStr,
  formatSinceDate,
} from "@/shared/DateHelper";
import CascService from "@/services/CascService";

export default {
  title: "Monitoring of kilometres travelled",
  watch: {
    getterCurrentClient: function () {
      this.initializeDates();
      this.initalizePayload();
      this.refreshData();
    },

    "$i18n.locale": function () {
      this.displaySinceDate();
    },

    getterLocos() {
      if (this.getterLocos.length) {
        this.getTotalKmByLoco();
      }
    },
  },
  methods: {
    ...mapActions("customer", {
      actionGetLocos: "loadLocos",
    }),

    displaySinceDate() {
      this.sinceDate = formatSinceDate(
        this.payload.startdate,
        this.$i18n.locale
      );
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllLoc) {
          this.payload.locomotives = [];
        } else {
          this.payload.locomotives = this.extractLoco(this.locoList);
          this.refreshData();
        }
      });
    },

    formatDistance(value) {
      return numStr(value);
    },

    getLocale(value) {
      if (value == "Titulaire") {
        return "message.page.titular";
      }

      if (value == "Reserve") {
        return "message.page.reserve";
      }

      if (value == "Performance") {
        return "message.page.performance";
      }

      if (value == "Spot") {
        return "message.page.spot";
      }
    },

    changeSort(index, data) {
      data.sort((a, b) => {
        if (index === "distance" || index === "tractionDistance" || index === "vehicleDistance"  || index === "otherDistance") {
          if (!this.isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        } else {
          if (!this.isDesc) {
            return a[index].localeCompare(b[index]);
          } else {
            return b[index].localeCompare(a[index]);
          }
        }
      });
      this.isDesc = !this.isDesc;
    },

    async loadLocos() {
      let payload = {
        customer: this.getterCurrentClient,
        start: firstDateOfCurrentMonth(),
        end: currentDate(),
      };
      await this.actionGetLocos(payload);
      this.payload.locomotives = this.getterLocos.map(l => l.loconum);
      if (this.payload.locomotives.length) {
        this.getTotalKmByLoco();
        this.getAvgKmByLoco();
        this.getChartTractionDatas();
        this.getTotalKm();
      } else {
        this.resetData();
      }
    },

    resetData() {
      this.totalKm = 0;
      this.datasTable = [];
      this.datasMonthTable = [];
      this.progress.totalData = false;
      this.progress.avgData = false;
      this.progress.chart = false;
      this.series = [
        {
          name: "",
          data: [],
        },
      ];
    },

    async refreshData() {
      this.payload.enddate = parseEndDate(this.endDateVal);
      this.payload.startdate = parseDate(this.startDateVal);
      this.loadLocos();
    },

    getTotalKm() {
      //this.sinceDate = formatDate(this.payload.startdate);
      this.displaySinceDate();

      CascService.findTotalDistanceByCustomer(this.payload).then((response) => {
        if (response.data.length == 0 || !response.data[0].totalkm) {
          this.totalKm = 0;
        } else {
          this.totalKm = numStr(response.data[0].totalkm.toFixed(0));
        }
      });
    },

    getTotalKmByLoco() {
      this.progress.totalData = true;
      CascService.findTotalDistanceLocosByCustomer(this.payload)
        .then((response) => {
          let totalKmData = this.getStatutContractuel(response.data);
          this.progress.totalData = false;
          this.getTractionKmByLoco(totalKmData);
        })
        .catch((err) => {
          console.log("GetTotalDistance:", err);
          this.datasTable = this.getStatutContractuel([]);
          this.progress.totalData = false;
        });
    },

    getTractionKmByLoco(totalKmData) {
      this.progress.totalData = true;
      CascService.findTractionDistanceLocosByCustomer(this.payload)
        .then((response) => {
          let tractionData = this.getStatutContractuel(response.data);
          const totalAndTractionData = totalKmData.map(({locomotive, contract, distance, status}) => ({locomotive: locomotive, contract: contract,
            distance: distance,
            status: status,
            tractionDistance: tractionData.find(t => t.locomotive === locomotive) ? tractionData.find(t => t.locomotive === locomotive).distance : 0
          })
          );
          this.getVehicleKmByLoco(totalAndTractionData);
          this.progress.totalData = false;
        })
        .catch((err) => {
          console.log("GetTractionDistance:", err);
          this.datasTable = this.getStatutContractuel([]);
          this.progress.totalData = false;
        });
    },

    getVehicleKmByLoco(totalAndTractionData) {
      this.progress.totalData = true;
      CascService.findVehicleDistanceLocosByCustomer(this.payload)
        .then((response) => {
          let vehicleData = this.getStatutContractuel(response.data);
          this.datasTable =  totalAndTractionData.map(({locomotive, contract, distance, status, tractionDistance}) => ({locomotive: locomotive, contract: contract,
            distance: distance,
            status: status,
            tractionDistance: tractionDistance,
            vehicleDistance: vehicleData.find(t => t.locomotive === locomotive) ? vehicleData.find(t => t.locomotive === locomotive).distance : 0
          })
          );
          this.progress.totalData = false;
        })
        .catch((err) => {
          console.log("GetTractionDistance:", err);
          this.datasTable = this.getStatutContractuel([]);
          this.progress.totalData = false;
        });
    },
    
    getAvgKmByLoco() {
      this.progress.avgData = true;
      CascService.findAvg(this.payload)
        .then((response) => {
          let avgKmData = this.getStatutContractuel(response.data);
          this.getAvgTractionKmByLoco(avgKmData);
          this.progress.avgData = false;
        })
        .catch((err) => {
          console.log("GetAvgDistance:", err);
          this.datasMonthTable = this.getStatutContractuel([]);
          this.progress.avgData = false;
        });
    },

    getAvgTractionKmByLoco(avgKmData) {
      this.progress.avgData = true;
      CascService.findTractionAvg(this.payload)
        .then((response) => {
          let tractionAvgData = this.getStatutContractuel(response.data);
          const totalAndTractionAvgData = avgKmData.map(({locomotive, contract, distance, status}) => ({locomotive: locomotive, contract: contract,
            distance: distance,
            status: status,
            tractionDistance: tractionAvgData.find(t => t.locomotive === locomotive) ? tractionAvgData.find(t => t.locomotive === locomotive).distance : 0
          })
          );
          this.getAvgVehicleKmByLoco(totalAndTractionAvgData);
          this.progress.avgData = false;
        })
        .catch((err) => {
          console.log("GetTractionAvgDistance:", err);
          this.datasMonthTable = this.getStatutContractuel([]);
          this.progress.avgData = false;
        });
    },

    getAvgVehicleKmByLoco(totalAndTractionAvgData) {
      this.progress.avgData = true;
      CascService.findVehicleAvg(this.payload)
        .then((response) => {
          let vehicleAvgData = this.getStatutContractuel(response.data);
          this.datasMonthTable =  totalAndTractionAvgData.map(({locomotive, contract, distance, status, tractionDistance}) => ({locomotive: locomotive, contract: contract,
            distance: distance,
            status: status,
            tractionDistance: tractionDistance,
            vehicleDistance: vehicleAvgData.find(t => t.locomotive === locomotive) ? vehicleAvgData.find(t => t.locomotive === locomotive).distance : 0
          })
          );
          this.progress.avgData = false;
        })
        .catch((err) => {
          console.log("GetVehicleAvgDistance:", err);
          this.datasMonthTable = this.getStatutContractuel([]);
          this.progress.avgData = false;
        });
    },
    
    getStatutContractuel(data) {
      let list = [];
      var i;
      for (i = 0; i < this.getterLocos.length; i++) {
        let find = data.find(
          (e) => e.locomotive == this.getterLocos[i].loconum
        );
        if (find !== undefined) {
          list.push({
            locomotive: this.getterLocos[i].loconum,
            contract: this.getterLocos[i].contrat,
            distance: find === undefined ? "" : find.distance,
            status: this.getterLocos[i].statutContractuel,
          });
        }
      }
      return list;
    },

    getChartTractionDatas() {
      this.progress.chart = true;
      CascService.findTractionDistanceLocosByCustomerAndDays(this.payload)
        .then((response) => {
          let retour = response.data;
          var i;
          var data = [];

          this.chartOptions.xaxis.categories.splice(
            0,
            this.chartOptions.xaxis.categories.length
          );
          
          for (i = 0; i < retour.length; i++) {
            data.push(retour[i].distance);
            this.chartOptions.xaxis.categories.push(retour[i].day);
          }

          this.$refs.chart.updateSeries([
            {
              name: "Traction",
              data: data,
            },
          ]);
          this.progress.chart = false;
          this.getChartVehicleDatas();
        })
        .catch((error) => {
          console.log("GetChartVehicleData: ", error);
          this.progress.chart = false;
        });
    },

    getChartVehicleDatas() {
      this.progress.chart = true;
      CascService.findVehicleDistanceLocosByCustomerAndDays(this.payload)
        .then((response) => {
          let retour = response.data;
          var i;
          var data = [];
          
          for (i = 0; i < this.chartOptions.xaxis.categories.length; i++) {
            data.push(retour.find(d => d.day === this.chartOptions.xaxis.categories[i]) ? 
            retour.find(d => d.day === this.chartOptions.xaxis.categories[i]).distance : 0);
          }

          this.$refs.chart.appendSeries(
            {
              name: "Vehicle",
              data: data,
            },
          );
          this.progress.chart = false;
        })
        .catch((error) => {
          console.log("GetChartVehicleData: ", error);
          this.progress.chart = false;
        });
    },
    
    initializeDates() {
      this.startDateVal = formatDate(firstDateOfCurrentMonth());
      this.endDateVal = formatDate(currentDate());
    },

    initalizePayload() {
      this.payload.startdate = firstDateOfCurrentMonth();
      this.payload.enddate = currentDate();
      this.payload.clients = [this.getterCurrentClient];
      this.payload.contrats = [];
      this.payload.series = [];
      this.payload.locomotives = [];
    },

    filterListByContrat(filter) {
      if (filter == "") {
        this.locoList = this.items;
        this.statusList = this.items;
        this.serailList = this.items;
      } else {
        let filterList = this.items.filter(function (item) {
          return filter.find((filteritem) => filteritem == item.agreement);
        });
        this.locoList = filterList;
        this.statusList = filterList;
        this.serailList = filterList;
      }
      this.payload.locomotives = this.getterLocos.map(l => l.loconum);
      this.payload.series = [];
      this.vstatus = [];
      this.refreshData();
    },

    filterListBySerial(filter) {
      if (filter == "") {
        this.locoList = this.items;
        this.statusList = this.items;
      } else {
        let filterList = this.items.filter(function (item) {
          return filter.find((filteritem) => filteritem == item.serial);
        });

        this.locoList = filterList;
        this.statusList = filterList;
      }
      this.payload.locomotives = this.getterLocos.map(l => l.loconum);
      this.vstatus = [];
      this.refreshData();
    },

    filterListByStatus(filter) {
      let series = this.payload.series;
      let filterList1;
      if (series.length == 0) {
        filterList1 = this.items;
        this.payload.locomotives = this.getterLocos.map(l => l.loconum);
      } else {
        filterList1 = this.items.filter(function (item) {
          return series.find((filteritem) => filteritem == item.serial);
        });
      }

      if (filter == "") {
        this.locoList = filterList1;
      } else {
        let filterList = filterList1.filter(function (item) {
          return filter.find(
            (filteritem) => filteritem == item.statutContractuel
          );
        });
        this.locoList = filterList;
      }
      this.payload.locomotives = this.extractLoco(this.locoList);
      this.refreshData();
    },

    extractLoco(data) {
      let locos = [];
      var i;
      for (i = 0; i < data.length; i++) {
        locos.push(data[i].loconum);
      }
      return locos;
    },
  },
  name: "KmPage",
  computed: {
    ...mapGetters("auth", {
      getterContrats: "getContrats",
      getterCurrentClient: "getCurrentClient",
      getterAuthData: "getAuthData",
    }),

    ...mapGetters("customer", {
      getterLocos: "getFilterLoc",
    }),
    selectAllLoc() {
      if (this.payload.locomotives == null) return false;
      return this.locoList.length === this.payload.locomotives.length;
    },

    selectSomeLoc() {
      if (this.payload.locomotives == null) return false;
      return this.payload.locomotives.length > 0 && !this.selectAllLoc;
    },

    icon() {
      if (this.selectAllLoc) return "mdi-close-box";
      if (this.selectSomeLoc) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    headersTable() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "locomotive",
          sortable: true,
        },
        {
          text: this.$t("message.page.cumul", { value: "default" }),
          value: "distance",
          sortable: true,
        },
        {
          text: "Traction",
          value: "tractionDistance",
          sortable: true,
        },
        {
          text: "Vehicle",
          value: "vehicleDistance",
          sortable: true,
        },
      ];
    },

    headersMoyTable() {
      return [
        {
          text: this.$t("message.pageKm.loco", { value: "default" }),
          value: "locomotive",
          sortable: true,
        },
        {
          text: this.$t("message.page.distance", { value: "default" }),
          value: "distance",
          sortable: true,
        },{
          text: "Traction",
          value: "tractionDistance",
          sortable: true,
        },
        {
          text: "Vehicle",
          value: "vehicleDistance",
          sortable: true,
        },
      ];
    },

    endDateDisp() {
      return this.endDateVal;
    },

    startDateDisp() {
      return this.startDateVal;
    },
  },
  mounted() {
    this.initializeDates();
    this.initalizePayload();
    this.loadLocos();
    this.items = this.getterLocos;
    this.serailList = this.getterLocos;
    this.locoList = this.getterLocos;
    this.statusList = this.getterLocos;
  },
  data: () => ({
    isDesc: false,
    payload: {
      startdate: null,
      enddate: null,
      clients: null,
      contrats: null,
      series: null,
      locomotives: null,
    },
    progress: {
      chart: true,
      avgData: true,
      totalData: true,
    },
    vstatus: [],
    totalKm: 0,
    items: [],
    serailList: [],
    locoList: [],
    statusList: [],
    sinceDate: "",
    datasTable: [],
    datasMonthTable: [],
    locos: [],
    endDateVal: null,
    endDateMenu: false,
    startDateVal: null,
    startDateMenu: false,
    series: [
      {
        name: "",
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        type: "bar",
        stacked: true,
        height: 350,
        redrawOnParentResize: true,
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },

      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 0,
      },
      colors: ["#EEBB07", "#6dbea7", "#003441", "#CCD2D5"],
      xaxis: {
        type: "date",
        categories: [],
        tickPlacement: "between",
        labels: {
          formatter: function (value) {
            if (value.length == 10) {
              const [month, day] = value.substr(5, 5).split("-");
              return `${day}-${month}`;
            }
          },
        },
      },
      tooltip: {
        x: {
          format: "dd-MM-yy",
        },
      },
    },
  }),
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    ApexCharts,
  },
};
</script>

<style scoped>
.portal-green-bg {
  height: 59px;
  color: #fff;
}

thead {
  background-color: #fafafa;
  color: #9faaaf;
}

tbody {
  color: #00475a;
  font-weight: bolder;
}

.portal-deep-blue-bg {
  height: 59px;
  color: #fff;
  text-transform: uppercase;
}

.v-card__text {
  padding: 0px;
}

.total {
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}

.distance {
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  color: #eebb07;
  font-size: 2.5em;
}

.km {
  color: #00475a !important;
}
</style>
